import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

import '../../../styles/report.css';

/*
  Using a <style> tag directly in a component is generally not standard practice,
  but it is the most effective way to encapsulate print-only styles within a single
  file modification as requested. The @media print query ensures these styles
  do not affect the on-screen display.
*/
const PrintStyles = () => (
    <style>
        {`
        @media print {
            .info-print-container {
                background-color: #fff;
                padding: 8px 0;
                page-break-inside: avoid;
            }

            .info-print-container .info-title {
                font-family: 'Times New Roman', Times, serif;
                font-size: 16pt;
                font-weight: bold;
                text-align: center;
                color: #000;
                margin-bottom: 16px;
            }

            .info-print-container .info-grid {
                display: grid;
                grid-template-columns: 3fr 9fr; /* Mimics xs={3} and xs={9} */
                row-gap: 8px;
                column-gap: 8px;
            }
            
            .info-print-container .info-key,
            .info-print-container .info-value {
                font-family: 'Times New Roman', Times, serif;
                font-size: 12pt;
                color: #000;
                line-height: 1.4;
                text-align: left;
            }

            .info-print-container .info-key {
                font-weight: bold;
            }
        }
        `}
    </style>
);


const Information = (props) => {
    // Assuming PrintView is passed as a direct prop
    const { Settings, OWS, PrintView } = props;

    const showName = Settings.OrganizationSettingValues['HIDE PARTICIPANT NAME'];
    const showNameFlag = (showName === '0' || showName === 0) ? true : false;

    const AssessmentInfo = OWS.AssessmentInfo;
    const { FirstCalculatedDate
        , FirstCalculatedDateText
        , FirstName
        , LastName
        , MostRecentCalc
        , MostRecentCalcText
        , NameText
        , ResponseCreateDate
        , ResponseCreateDateText
        , AssessmentText } = AssessmentInfo;

    if (PrintView === true) {
        return (
            <>
                <PrintStyles />
                <div className="info-print-container">
                    <div className="info-title">
                        {AssessmentText}
                    </div>
                    <div className="info-grid">
                        {showNameFlag && (
                            <>
                                <div className="info-key">{NameText}</div>
                                <div className="info-value">{FirstName} {LastName}</div>
                            </>
                        )}
                        <div className="info-key">{ResponseCreateDateText}</div>
                        <div className="info-value">{ResponseCreateDate}</div>

                        <div className="info-key">{FirstCalculatedDateText}</div>
                        <div className="info-value">{FirstCalculatedDate}</div>

                        <div className="info-key">{MostRecentCalcText}</div>
                        <div className="info-value">{MostRecentCalc}</div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <Box sx={{}}>
            <Typography variant="body1" fontWeight="bold" style={{ textAlign: 'center', fontSize: "20px" }}>
                {AssessmentText}
            </Typography>
            <Box>
                <Grid container direction="row" spacing={1} sx={{ paddingTop: "24px" }}>
                    {showNameFlag && (
                        <Grid item xs={3}>
                            <Typography variant="subtitle2" align="left">{NameText}</Typography>
                        </Grid>
                    )}
                    {showNameFlag && (
                        <Grid item xs={9}>
                            <Typography variant="body2" align="left">{FirstName} {LastName}</Typography>
                        </Grid>
                    )}
                    <Grid item xs={3}>
                        <Typography variant="subtitle2" align="left">{ResponseCreateDateText}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body2" align="left">{ResponseCreateDate}</Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Typography variant="subtitle2" align="left">{FirstCalculatedDateText}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body2" align="left">{FirstCalculatedDate}</Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Typography variant="subtitle2" align="left">{MostRecentCalcText}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body2" align="left">{MostRecentCalc}</Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default Information;